function getSponsor(cert) {
  if (!cert.sponsors || !cert.sponsors.name) return '';
  return cert.sponsors.name.replace(/,/g, '.');
}

function checkProp(data) {
  if (data) return data;
  return '';
}

function exportTable($filter, regulatorIds, filteredCerts) {
  const headers = ['Date', 'Certificate', 'Sponsor', 'Delivery Method', 'PDF', 'Subject Area'];
  let categoriesHours = [];
  const categories = [];
  const body = filteredCerts.filter(({ hours_applied }) => hours_applied).map(cert => {
    let hours = '';
    const categoriesMap = {};

    Object.keys(cert.hours_applied).forEach(regulator => {
      if (!regulatorIds.includes(regulator)) return;
      Object.keys(cert.hours_applied[regulator]).forEach(category => {
        const text = regulator.replace(/_/g, ' ');
        const value = $filter('CapitalizeFirstLetter')(text);
        const regulatorCategoryKey = `${value}: ${category}`;

        categoriesMap[regulatorCategoryKey] = cert.hours_applied[regulator][category];
        if (!categories.includes(regulatorCategoryKey)) {
          categories.push(regulatorCategoryKey);
          headers.push(regulatorCategoryKey);
        }
      });
    });

    categoriesHours = categories.map(regulatorCategoryKey => categoriesMap[regulatorCategoryKey] || '');

    if (cert.hours) hours = cert.hours.map(({ subject_area, credits }) => `${subject_area}: ${credits}`).join(' + ');

    return [
      `${checkProp($filter('date')(cert.date, 'shortDate')).replace(/,/g, '.')}`,
      `${checkProp(cert.cert).replace(/,/g, '.')}`,
      `${getSponsor(cert)}`,
      `${checkProp(cert.delivery).replace(/,/g, '.')}`,
      `${checkProp(cert.pdf)}`,
      `${hours}`,
      ...categoriesHours
    ];
  });

  return { body, headers };
}

export { exportTable };



// WEBPACK FOOTER //
// ./src/app/controllers/users/report/exportTable.js